<!-- BEGIN: Subheader -->
<div class="m-subheader">
  <div class="d-flex align-items-center">
    <div class="mr-auto">
      <h3 class="m-subheader__title">
        {{ 'bank-list.title' | transloco }}
      </h3>
    </div>
    <div>
      <app-bank-new [id]="bankId" (update)="updater($event)"></app-bank-new>
    </div>
  </div>
</div>
<!-- END: Subheader -->
<div class="m-content">
  <!--Begin::Main Portlet-->
  <div class="row">
    <div class="col-sm-12">
      <div class="m-portlet m-portlet--full-height">
        <div class="m-portlet__body">
          <p *ngIf="pagination?.allItemCount">{{ 'bank-list.totalBanks' | transloco }} {{ pagination?.allItemCount }}</p>

          <div class="m_datatable m-datatable--va-top m-datatable m-datatable--default m-datatable--loaded m--margin-top-30 m--margin-bottom-30" *ngIf="list.length && !isLoading.list">
            <table class="m-datatable__table">
              <thead class="m-datatable__head">
                <tr class="m-datatable__row m-datatable__row--head">
                  <th class="m-datatable__cell">
                    <span>#</span>
                  </th>
                  <th class="m-datatable__cell">
                    <span>{{ 'bank-list.name' | transloco }}</span>
                  </th>
                  <th class="m-datatable__cell">
                    <span>{{ 'bank-list.address' | transloco }}</span>
                  </th>
                  <th class="m-datatable__cell">
                    <span>{{ 'bank-list.bic' | transloco }}</span>
                  </th>
                  <th class="m-datatable__cell text-right">
                    <span>{{ 'bank-list.events' | transloco }}</span>
                  </th>
                </tr>
              </thead>
              <tbody class="m-datatable__body">
                <tr *ngFor="let even = even; let i = index; let item of list"
                  class="m-datatable__row" [ngClass]="{ 'm-datatable__row--even': even, 'm-datatable__row--disabled': !item.enabled }">
                  <td class="m-datatable__cell">
                    {{ i + counter }}
                  </td>
                  <td class="m-datatable__cell">
                    {{ item?.name }}
                  </td>
                  <td class="m-datatable__cell">
                    {{ item?.address }}
                  </td>
                  <td class="m-datatable__cell">
                    {{ item.bic }}
                  </td>
                  <td class="m-datatable__cell text-nowrap text-right" style="min-width: 102px;">
                    <a (click)="updateItem(item)" class="btn btn-outline-primary btn-sm m-btn m-btn--icon" [title]="'bank-list.change' | transloco">
                      <i class="la la-edit"></i>
                    </a>

                    <a (click)="deleteItem(item.id)" class="btn btn-outline-danger m-btn btn-sm m-btn--icon" [title]="'bank-list.deleteBank' | transloco">
                      <i class="la la-trash"></i>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <hx-loader [length]="list.length" [isLoading]="isLoading.list"></hx-loader>

          <div class="m--align-center" *ngIf="list.length && !isLoading.list && pagination.allItemCount > 0">
            <ngb-pagination [maxSize]="5" [rotate]="true" [collectionSize]="pagination.allItemCount"
                            [(page)]="pagination.currentPage" [pageSize]="pagination.limit" (pageChange)="pageChanged($event)" class="d-flex justify-content-center mt-4">
            </ngb-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--End::Main Portlet-->
</div>
